import React, { useCallback, useState } from 'react';
import { BookingModal } from '../components/BookingModal';
import { BookingSection } from '../components/BookingSection';
import { EventsSection } from '../components/EventsSection';
import { Footer } from '../components/Footer';
import { GallerySection } from '../components/GallerySection';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { HorsesSection } from '../components/HorsesSection';
import { RidesSection } from '../components/RidesSection';
import { RulesSection } from '../components/RulesSection';
export function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [bookingRide, setBookingRide] = useState<string | null>(null);
  const openBooking = useCallback((rideId: string | null) => {
    setBookingRide(rideId);
    setBookingOpen(true);
  }, []);
  const closeBooking = useCallback(() => setBookingOpen(false), []);
  return <div className="min-h-screen w-full bg-cream font-sans text-bark" data-id="element-277" data-mp="3oyynngc2jrm2">
      <Header data-id="element-278" data-mp="30vgouqlzr7t6" />
      <main data-id="element-279" data-mp="30w0582vzto53">
        <Hero data-id="element-280" data-mp="30uoz3wf2s4at" />
        <GallerySection data-id="element-281" data-mp="2vxoulpxvj9lt" />
        <HorsesSection data-id="element-282" data-mp="2vxf3fz13ewej" />
        <RidesSection onBook={openBooking} data-id="element-283" data-mp="2vyzw1j3uk59r" />
        <BookingSection onBook={openBooking} data-id="element-284" data-mp="2qylnlzyc2tb7" />
        <EventsSection data-id="element-285" data-mp="2qxal03gmjrlo" />
        <RulesSection data-id="element-286" data-mp="2qwsjosf3un6w" />
      </main>
      <Footer data-id="element-287" data-mp="2mxa6kitizgem" />
      <BookingModal open={bookingOpen} rideId={bookingRide} onClose={closeBooking} data-id="element-288" data-mp="2mxs21d8d5qlh" />
    </div>;
}